"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildURL = exports.blockchain = exports.messages = exports.wallet = exports.marketplace = exports.utils = exports.user = exports.transaction = exports.product = exports.payment = exports.legal = exports.collection = exports.space = exports.news = exports.client = exports.axios = exports.auth = void 0;
var auth_class_1 = require("./auth.class");
Object.defineProperty(exports, "auth", { enumerable: true, get: function () { return auth_class_1.auth; } });
var axios_class_1 = require("./axios.class");
Object.defineProperty(exports, "axios", { enumerable: true, get: function () { return axios_class_1.axios; } });
var clients_class_1 = require("./clients.class");
Object.defineProperty(exports, "client", { enumerable: true, get: function () { return clients_class_1.client; } });
var news_class_1 = require("./news.class");
Object.defineProperty(exports, "news", { enumerable: true, get: function () { return news_class_1.news; } });
var space_class_1 = require("./space.class");
Object.defineProperty(exports, "space", { enumerable: true, get: function () { return space_class_1.space; } });
var collections_class_1 = require("./collections.class");
Object.defineProperty(exports, "collection", { enumerable: true, get: function () { return collections_class_1.collection; } });
var legals_class_1 = require("./legals.class");
Object.defineProperty(exports, "legal", { enumerable: true, get: function () { return legals_class_1.legal; } });
var payments_class_1 = require("./payments.class");
Object.defineProperty(exports, "payment", { enumerable: true, get: function () { return payments_class_1.payment; } });
var products_class_1 = require("./products.class");
Object.defineProperty(exports, "product", { enumerable: true, get: function () { return products_class_1.product; } });
var transactions_class_1 = require("./transactions.class");
Object.defineProperty(exports, "transaction", { enumerable: true, get: function () { return transactions_class_1.transaction; } });
var users_class_1 = require("./users.class");
Object.defineProperty(exports, "user", { enumerable: true, get: function () { return users_class_1.user; } });
var utils_class_1 = require("./utils.class");
Object.defineProperty(exports, "utils", { enumerable: true, get: function () { return utils_class_1.utils; } });
var marketplace_class_1 = require("./marketplace.class");
Object.defineProperty(exports, "marketplace", { enumerable: true, get: function () { return marketplace_class_1.marketplace; } });
var wallets_class_1 = require("./wallets.class");
Object.defineProperty(exports, "wallet", { enumerable: true, get: function () { return wallets_class_1.wallet; } });
var messages_class_1 = require("./messages.class");
Object.defineProperty(exports, "messages", { enumerable: true, get: function () { return messages_class_1.messages; } });
var blockchain_class_1 = require("./blockchain.class");
Object.defineProperty(exports, "blockchain", { enumerable: true, get: function () { return blockchain_class_1.blockchain; } });
function buildURL(path, queryParams) {
    const queryString = Object.keys(queryParams)
        .filter(key => queryParams[key] !== undefined)
        .map(key => `${key}=${queryParams[key]}`)
        .join('&');
    return queryString ? `${path}?${queryString}` : path;
}
exports.buildURL = buildURL;
